import { buildQuerystring } from "../../utils/querystring";
import { getInitialSortField } from "./misc";

export function updateUrlFromState(state) {
    const params = buildParamsFromState(state);
    history.replaceState({}, '', buildUrlFromParams(location.pathname, params));
}

export function buildParamsFromState(state) {
    const { activeFilters } = state.mutableFiltering;
    const { searchQuery } = state.mutableSearching;
    const { sortBy } = state.mutableSorting;
    const { descending } = state.mutableSorting;

    const params = {};

    activeFilters.forEach(item => {
        const field = item.field;

        if ( !(field in params) ) {
            params[field] = [];
        }
        params[field].push(item.value)
    });

    if ( searchQuery !== '' ) {
        params['searchQuery'] = [searchQuery]  // expected format is an array of items
    }

    if ( sortBy !== null && sortBy !== undefined && sortBy !== getInitialSortField(state.immutableBaseData) ) {
        params['sortBy'] = [sortBy]  // expected format is an array of items
    }

    if ( descending === false ) {
        // because true is the default state, we only need to set this in the url when it's false
        params['desc'] = [descending]  // expected format is an array of items
    }

    return params;

}

export function buildUrlFromParams(currentPath, params) {
    return `${currentPath}${buildQuerystring(params)}`;
}
